module.exports = __webpack_public_path__ + "img/dice-twenty-faces-twenty.6288feb0.png";